import React, { Fragment } from "react";
import IndustriesSubTile from "./IndustriesSubTile";
import PropTypes from "prop-types";
import { BarLoader } from "react-spinners";

class IndustriesSub extends React.Component {
    render() {
        const ln = this.props.industries.length;

        return (
            <Fragment>
                <div className="tiles-container">
                    <nav role="navigation" className="tile-row tile-row--sub">
                        {ln > 0 ? (
                            this.props.sects
                                .map((sector, i) => (
                                    <IndustriesSubTile
                                        {...this.props}
                                        i={i}
                                        key={i}
                                        sectors={sector}
                                    />
                                ))
                                .filter(
                                    sect =>
                                        sect.props.sectors.parent ===
                                        sect.props.parent
                                )
                        ) : (
                            <div className="spinner-holder">
                                <BarLoader color={"#150F96"} />
                            </div>
                        )}
                    </nav>
                </div>
            </Fragment>
        );
    }
}

export default IndustriesSub;



// WEBPACK FOOTER //
// ./src/components/IndustriesSub.js